import { useEffect, useRef } from "react";
import NotificationList from "./Notification";

const NotificationModal = ({ setNotificationsOpen }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOrScrollOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setNotificationsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOrScrollOutside);
    document.addEventListener("scroll", handleClickOrScrollOutside, true); // 'true' makes it listen in the capturing phase

    return () => {
      document.removeEventListener("mousedown", handleClickOrScrollOutside);
      document.removeEventListener("scroll", handleClickOrScrollOutside, true);
    };
  }, [setNotificationsOpen]);

  return (
    <div ref={modalRef} className="notification-modal">
      <NotificationList />
    </div>
  );
};

export default NotificationModal;
